export default __webpack_public_path__ + "static/media/purpule-gradient-box.3074ece2.svg";